import Router from '../Router';
import { StatsController } from '../../controllers';

export default class StatsRouter extends Router {
	initialize(options) {
		this.typeMenu = 'stats';
		this.controller = new StatsController(options);

		this.authOnly = {
			statsCentre: false
		}
	}

	get appRoutes() {
		return {
			'stats-centre': 'statsCentre',
			'player-profile(/:player_id)': 'playerProfile',
			'compare(/:player_id)': 'playerComparison',
		};
	}
}